import React from 'react'
import {Modal} from 'antd'
import {withRouter} from 'react-router-dom'
import {getOrderingSteps} from '../helpers'

const StepRenderer = ({
  history,
  defaultStep,
  scope,
  removeReservation,
  isRemovingReservation: loading,
  webOrder,
  estate,
  viewer,
  productSelection,
  queryParams,
  setQueryParams,
  ...rest
}) => {
  const goToStep = (step) => setQueryParams({step})

  const steps = getOrderingSteps({webOrder, estate, productSelection, viewer})
  const step = steps.find(s => s.scope === scope && s.step === (queryParams.step || defaultStep))

  if (!step || !step.canRenderStep()) {
    goToStep(defaultStep)
    return null
  }

  function showReservedBookingWarning() {
    return !!(!['booking', 'oppsummering'].includes(step.step) &&
      webOrder &&
      webOrder.reservedBooking &&
      webOrder.reservedBooking.id)
  }

  const Component = step.Component

  return (
    <>
      <Modal
        visible={showReservedBookingWarning()}
        closable={false}
        // Cannot use goToStep because estate steps are on a different path to order steps
        onCancel={() => history.push(`/bestilling/${webOrder.id}?step=booking`)}
        onOk={removeReservation}
        okButtonProps={{loading}}
      >
        <p>For å gjøre endringer i bestillingen, må den reserverte tiden du valgte først fjernes.</p>
        <p>Fjern den reserverte tiden og fortsett?</p>
      </Modal>
      <Component
        webOrder={webOrder}
        estate={estate}
        viewer={viewer}
        productSelection={productSelection}
        goToPreviousStep={() => step.previousStep && goToStep(step.previousStep())}
        goToNextStep={() => step.nextStep && goToStep(step.nextStep())}
        {...rest}
      />
    </>
  )
}

export default withRouter(StepRenderer)
